import { render, staticRenderFns } from "./QuestionsurveyAdd.vue?vue&type=template&id=55eb6f06&scoped=true"
import script from "./QuestionsurveyAdd.vue?vue&type=script&lang=js"
export * from "./QuestionsurveyAdd.vue?vue&type=script&lang=js"
import style0 from "./QuestionsurveyAdd.vue?vue&type=style&index=0&id=55eb6f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eb6f06",
  null
  
)

export default component.exports